import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { getCall, addTokenToUrl } from './apicalls.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SiteApiService {
    private httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        }),
    };

    constructor(public _http: HttpClient) {}

    getAppSettings(): Observable<any> {
        const url = getCall('settings');
        return this._http.get(url);
    }

    getPages(pageSlug: string, token: string = null) {
        let url = getCall('page', pageSlug);
        url = addTokenToUrl(url, token);

        return this._http.get(url, this.httpOptions);
    }

    postPages(pageSlug: string, form: any, token: string = null) {
        let url = getCall('page', pageSlug);
        url = addTokenToUrl(url, token);
        const jsonBody = {
            content: {
                form: form,
            },
        };

        return this._http.post(url, jsonBody, this.httpOptions);
    }

    getImage(id: string): Observable<Blob> {
        const url = getCall('storage', id, {
            access: localStorage.getItem('user-access'),
        });
        return this._http.get(url, {
            headers: new HttpHeaders({
                Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            }),
            responseType: 'blob',
        });
    }
}
